module.exports = __webpack_public_path__ + "static/media/pa6.76423871.png";